import React, { useState } from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { useChangePasswordMutation } from '../../../store/Reducer/user-profile';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export default function Security() {
    const { t } = useTranslation();
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const navigate = useNavigate();

    const [changePassword, { isLoading }] = useChangePasswordMutation();

    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        const { currentPassword, newPassword, confirmPassword } = formData;

        // Check if new password and confirm password match
        if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        // Prepare data to send to the backend
        const payload = { currentPassword, newPassword };

        try {
            const response = await changePassword(payload);
            console.log('changePassword = ', response?.data);

            // Handle errors from the backend
            if (response.error) {
                const errorMessage = response.error?.data?.message || 'An unexpected error occurred.';
                toast.error(errorMessage);
                return;
            }

            // Handle success
            if (response?.data?.message) {
                toast.success(response?.data?.message);
            } else {
                toast.success('Profile updated successfully!');
            }

            navigate("/user-dashboard")

            setFormData({
                currentPassword: '',
                newPassword: '',
                confirmPassword: '',
            })
        } catch (error) {
            const errorMessage = error?.response?.data?.message || error.message || 'An error occurred.';
            console.error('Unexpected Error:', error);
            toast.error(errorMessage);
        }
    };

    return (
        <div className="bg-white shadow-xl rounded-2xl overflow-hidden">
            <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-6">
                <div className="space-y-6">
                    <div className="space-y-2">
                        <label htmlFor="currentPassword" className="text-sm font-medium text-gray-700">
                            {t("security_tab_current_password")}
                        </label>
                        <div className="relative">
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id="currentPassword"
                                value={formData.currentPassword}
                                onChange={handleChange}
                                className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-transparent transition-shadow focus:outline-none"
                                placeholder="Enter current password"
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2"
                            >
                                {showPassword ? <EyeOff className="w-5 h-5 text-gray-400" /> : <Eye className="w-5 h-5 text-gray-400" />}
                            </button>
                        </div>
                    </div>

                    <div className="space-y-2">
                        <label htmlFor="newPassword" className="text-sm font-medium text-gray-700">
                            {t("security_tab_new_password")}
                        </label>
                        <div className="relative">
                            <input
                                type={showNewPassword ? 'text' : 'password'}
                                id="newPassword"
                                value={formData.newPassword}
                                onChange={handleChange}
                                className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-transparent transition-shadow focus:outline-none"
                                placeholder="Enter new password"
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowNewPassword(!showNewPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2"
                            >
                                {showNewPassword ? <EyeOff className="w-5 h-5 text-gray-400" /> : <Eye className="w-5 h-5 text-gray-400" />}
                            </button>
                        </div>
                    </div>

                    <div className="space-y-2">
                        <label htmlFor="confirmPassword" className="text-sm font-medium text-gray-700">
                            {t("security_tab_confirm_new_password")}
                        </label>
                        <div className="relative">
                            <input
                                type={showConfirmPassword ? 'text' : 'password'}
                                id="confirmPassword"
                                value={formData.confirmPassword}
                                onChange={handleChange}
                                className="w-full px-4 py-2 rounded-lg border border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-transparent transition-shadow focus:outline-none"
                                placeholder="Confirm new password"
                                required
                            />
                            <button
                                type="button"
                                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                className="absolute right-3 top-1/2 -translate-y-1/2"
                            >
                                {showConfirmPassword ? <EyeOff className="w-5 h-5 text-gray-400" /> : <Eye className="w-5 h-5 text-gray-400" />}
                            </button>
                        </div>
                    </div>
                </div>

                <div className="flex justify-end space-x-4 pt-6 border-t">
                    <button
                        onClick={() => navigate('/user-dashboard')}
                        type="button"
                        className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                    >
                        {t("universalCancel")}
                    </button>
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        {isLoading ? t("user_profile_btn_text_saving") : t("user_profile_btn_text")}
                    </button>
                </div>
            </form>
        </div>
    )
}